import type { FeatureRequest } from '@/hooks/useFeatureRequests';

/**
 * A7O-11: die Roadmap war eine flache Liste nach Stimmen, 14 erledigte
 * Eintraege standen vor allem, was noch offen ist. Jetzt vier Abschnitte in
 * Arbeitsreihenfolge, innerhalb nach Stimmen.
 */
export type RoadmapSectionKey = 'in_progress' | 'planned' | 'completed' | 'declined';

export const ROADMAP_SECTION_ORDER: RoadmapSectionKey[] = ['in_progress', 'planned', 'completed', 'declined'];

const SECTION_OF: Record<string, RoadmapSectionKey> = {
  in_progress: 'in_progress',
  planned: 'planned',
  under_review: 'planned',
  completed: 'completed',
  declined: 'declined',
};

export function groupFeatureRequests(
  requests: FeatureRequest[],
): { key: RoadmapSectionKey; requests: FeatureRequest[] }[] {
  const buckets = new Map<RoadmapSectionKey, FeatureRequest[]>(ROADMAP_SECTION_ORDER.map((k) => [k, []]));
  for (const request of requests) {
    buckets.get(SECTION_OF[request.status] ?? 'planned')!.push(request);
  }
  return ROADMAP_SECTION_ORDER.map((key) => ({
    key,
    requests: [...buckets.get(key)!].sort((a, b) => b.vote_count - a.vote_count),
  })).filter((section) => section.requests.length > 0);
}

/** Abstimmen nur, solange ueber den Eintrag noch nicht entschieden ist. */
export function isVotingOpen(status: string): boolean {
  return status !== 'completed' && status !== 'declined';
}
